import { Boost } from '@packages/types';
import { isBoostExtraCancellation } from '@packages/utils';

import { Button } from '@elements/button';
import { Text } from '@elements/text';
import { useModalStore } from '@store';
import { useFeatureFlagsStore } from '@store/featureFlags';
import { useGlobalStore } from '@store/global';
import { testProps } from '@utils';

export const CanstarExtraCancellationPopover = ({ boost }: { boost: Boost }) => {
  const openModal = useModalStore(state => state.openModal);
  const isExtraCancellationAddedByDefaultForCanstar = useGlobalStore(
    state => state.isExtraCancellationAddedByDefaultForCanstar,
  );
  const isEnabled = useFeatureFlagsStore(
    state =>
      state.featureFlags?.['extra-cancellation-added-by-default-for-canstar-tooltip']?.isEnabled,
  );
  const isExtraCancellationBoost = isBoostExtraCancellation(boost);
  const canstarExtraCancellationPayload = useFeatureFlagsStore(
    state =>
      state.featureFlags?.['extra-cancellation-added-by-default-for-canstar-tooltip']?.payload,
  );

  const onInfoClick = () => {
    if (
      !canstarExtraCancellationPayload?.extraCancellationPopover?.heading ||
      !canstarExtraCancellationPayload?.extraCancellationPopover?.content
    ) {
      return;
    }

    openModal('Modal', {
      titleProps: {
        children: canstarExtraCancellationPayload?.extraCancellationPopover?.heading,
      },
      bodyTextProps: {
        children: canstarExtraCancellationPayload?.extraCancellationPopover?.content,
      },
      size: 'lg',
      actions: [
        {
          variant: 'primary',
          title: 'OK',
        },
      ],
    });
  };

  if (isExtraCancellationAddedByDefaultForCanstar && isExtraCancellationBoost && isEnabled)
    return (
      <div className="flex flex-row items-center">
        <Text variant="subHeading-14/r" {...testProps('text-canstar-title')}>
          {canstarExtraCancellationPayload?.extraCancellationPopover.title}
        </Text>
        <Button icon="info" variant="tertiary" size="sm" onClick={onInfoClick} />
      </div>
    );

  return null;
};
